import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '@/redux/hooks'
import { AppDispatch } from '@/redux/store'
import { verifyEmailRegistration } from '@/redux/asyncThunks/user'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { AlertCircle, CheckCircle2 } from 'lucide-react'
import ROUTES from '@/routes/routes'

const VerifyEmail = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const { loading, error, successMessage } = useAppSelector(
    (state) => state.user
  )

  useEffect(() => {
    const key = searchParams.get('key')
    if (key) {
      dispatch(verifyEmailRegistration({ key }))
    }
  }, [searchParams, dispatch])

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => {
        navigate(ROUTES.LOGIN)
      }, 3000)
      return () => clearTimeout(timer)
    }
  }, [successMessage, navigate])
  return (
    <div className='flex h-screen w-screen flex-col md:flex-row'>
      <div className='relative hidden flex-1 md:block'>
        <img
          src='/images/auth-background.svg'
          alt='Auth background'
          className='absolute w-1/2 object-cover md:h-full md:w-5/6'
        />
        <div className='flex h-full items-center justify-center'>
          <img
            src='/images/auth-avatar.svg'
            alt='Auth Avatar'
            className='absolute z-10 object-fill md:h-full md:w-auto'
          />
        </div>
      </div>

      <div className='flex flex-1 flex-col items-center justify-center'>
        <div className='flex justify-center'>
          <img
            src='/images/oge.svg'
            alt='OGE logo'
            className='w-1/2 object-contain md:w-full'
          />
        </div>
        <div className='flex w-3/4 flex-col items-center md:w-full'>
          <Card className='w-full max-w-md border-none shadow-none'>
            <CardHeader className='space-y-1 flex flex-col items-center'>
              <CardTitle className='text-4xl font-bold'>
                Email Verification
              </CardTitle>
            </CardHeader>
            <CardContent className='space-y-4'>
              {loading && (
                <div className='flex flex-col items-center justify-center'>
                  <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900'></div>
                  <p className='mt-4 text-gray-600'>Verifying your email...</p>
                </div>
              )}

              {error && (
                <div className='text-red-500 text-sm flex justify-center gap-2'>
                  <AlertCircle className='h-5 w-5' />
                  {error}
                </div>
              )}

              {successMessage && (
                <div className='text-green-500 text-sm flex flex-col items-center gap-2'>
                  <CheckCircle2 className='h-5 w-5' />
                  <p>{successMessage}</p>
                  <p className='text-gray-600'>Redirecting to login...</p>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default VerifyEmail
